<template>
  <div>
    <Modal
      :value="medal"
      @on-visible-change="visibleChange"
      title="项目编辑"
      width="1000px"
      class="detail_p"
      :mask-closable="false"
    >
      <Form
        inline
        :label-width="100"
        label-position="right"
        ref="projectData"
        :model="projectData"
      >
        <div v-if="!(editType==='member')">
          <h3>
            项目基本资料
          </h3>
          <FormItem
            label="项目名称"
            prop="projectName"
            style="width: 535px;"
          >
            <Input
              v-model="projectData.projectName"
              class="ivu-width"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            ></Input>
          </FormItem>
          <FormItem
            label="立项时间"
            prop="newProjectTime"
          >
            <Input
              v-model="projectData.newProjectTime"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="所属部门"
            prop="district"
          >
            <Input v-model="projectData.district" class="ivu-width" :disabled="true"></Input>
          </FormItem>
          <FormItem
            label="项目简称"
            prop="projectShort"
          >
            <Input
              v-model="projectData.projectShort"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="项目编号全称"
            prop="projectFull"
          >
            <Input
              v-model="projectData.projectFull"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="所属地区"
            prop="area"
          >
            <Input v-model="projectData.area" class="ivu-width" disabled="disabled"></Input>
          </FormItem>
          <FormItem
            label="当地编号"
            prop="localNumber"
          >
            <Input
              v-model="projectData.localNumber"
              class="ivu-width"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            ></Input>
          </FormItem>
          <FormItem
            label="分子公司"
            prop="childcompany"
          >
            <Input v-model="projectData.companyName" class="ivu-width" :disabled="true" style="width:250px;"></Input>
            <!-- <Select
              disabled="disabled"
              v-model="projectData.companyName"
              style="width: 250px;"
            >
              <Option
                v-for="company in extraInfo.childCompanies"
                :key="company.id"
                :value="company.cName"
              >{{company.cName}}</Option>
            </Select> -->
          </FormItem>
          <FormItem
            label="项目状态"
            prop="projectState"
          >
            <Input
              v-model="projectData.projectState"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="开标时间"
            prop="clMeetingRoom"
          >
            <Input
              v-model="clMeetingRoom.beginTime"
              class="ivu-width"
              disabled="disabled"
              style="width:150px;margin-right:10px;"
            ></Input>
            <Button
              type="primary"
              size="small"
              @click="deleteRoom"
              v-if="clMeetingRoom.beginTime !== '暂无'"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            >删除</Button>
          </FormItem>
          <FormItem
            label="是否有居间服务费"
            prop="intermediary"
          >
            <Input
              v-model="projectData.intermediary"
              class="ivu-width"
              :disabled="true"
              style="width:50px"
            ></Input>
          </FormItem>
          <FormItem
            label="备注信息"
            prop="comment"
            style="width: 800px;"
          >
            <Input
              v-model="projectData.comment"
              class="ivu-width"
              :disabled="!(editType==='info') && !(editType==='projectEdit') && !(editType==='member')"
            ></Input>
          </FormItem>
        </div>
        <div v-if="!(editType==='member')">
          <h3>
            项目采购类别及客户行业分类
          </h3>
          <FormItem
            label="业务范围"
            prop="businessType"
          >
            <Select
              disabled="disabled"
              style="width:160px;"
              class="ivu-width"
              v-model="projectData.businessType"
              @on-change="businessChange"
            >
              <Option
                v-for="cgmethod in extraInfo.businesstype"
                :key="cgmethod['itemName']"
                :value="cgmethod['itemName']"
              >{{cgmethod['itemName']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="项目性质"
            prop="projectProperty"
          >
            <!-- <Input v-model="projectData.projectProperty" class="ivu-width"></Input> -->
            <Select
              disabled="disabled"
              style="width:160px;"
              class="ivu-width"
              v-model="projectData.projectProperty"
              @on-change="bidplatform"
            >
              <Option
                v-for="cgmethod in extraInfo.projectnatureArr"
                :value="cgmethod['itemName']"
                :key="cgmethod['itemName']"
              >{{cgmethod['itemName']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="招标平台"
            prop="bidPlatform"
          >
            <Input
              v-model="projectData.bidPlatform"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="采购类别"
            prop="buyerNature"
          >
            <!-- <Input v-model="projectData.buyerNature" class="ivu-width" :disabled="!(editType==='info') && !(editType==='projectEdit')"></Input> -->
            <Select
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
              style="width:160px;"
              class="ivu-width"
              v-model="projectData.buyerNature"
            >
              <Option
                v-for="cgmethod in extraInfo.cgtype"
                :value="cgmethod['itemName']"
                :key="cgmethod['itemName']"
              >{{cgmethod['itemName']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="资金来源"
            prop="capitalSource"
          >
            <!-- <Input v-model="projectData.capitalSource" class="ivu-width"></Input> -->
            <Select
              disabled="disabled"
              style="width:160px;"
              class="ivu-width"
              v-model="projectData.capitalSource"
            >
              <Option
                v-for="cgmethod in extraInfo.moneysource"
                :value="cgmethod['itemName']"
                :key="cgmethod['itemName']"
              >{{cgmethod['itemName']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="采购方式"
            prop="buyerModes"
          >
            <!-- <Input v-model="projectData.buyerModes" class="ivu-width" disabled="disabled"></Input> -->
            <Select
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
              style="width:150px;"
              v-model="projectData.buyerModes"
            >
              <Option
                v-for="cgmethod in extraInfo.cgmethodArr"
                :value="cgmethod['itemName']"
                :key="cgmethod['itemName']"
              >{{cgmethod['itemName']}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="采购进出口"
            prop="import"
          >
            <Input
              v-model="projectData.import"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="是否有论证"
            prop="argument"
          >
            <Input
              v-model="projectData.argument"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <!-- <FormItem label="业务范围" prop="businessType">
            <Input v-model="projectData.businessType" class="ivu-width" disabled="disabled"></Input>
          </FormItem> -->
          <FormItem
            label="包组数量"
            prop="groupCount"
          >
            <Input
              v-model="projectData.groupCount"
              class="ivu-width"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            ></Input>
          </FormItem>
          <FormItem
            label="采购内容"
            prop="purchaseContent"
            style="width: 535px;"
          >
            <Input
              v-model="projectData.purchaseContent"
              class="ivu-width"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            ></Input>
          </FormItem>
        </div>
        <div v-if="!(editType==='member')">
          <h3>
            集团客户
          </h3>
          <FormItem
            label="集团客户"
            prop="specialCustomer"
            style="width: 400px;"
          >
            <!-- <Input v-model="projectData.specialCustomer" class="ivu-width" :disabled="!(editType==='info')"></Input> -->
            <Input
              v-model="projectData.specialCustomer"
              class="ivu-width"
              :disabled="true"
              style="width:280px;"
            ></Input>
          </FormItem>
          <FormItem
            label="分支机构"
            prop="branchName"
            style="width: 400px;"
          >
            <!-- <Input v-model="projectData.branchName" class="ivu-width" :disabled="!(editType==='info')"></Input> -->
            <Input
              v-model="projectData.branchName"
              class="ivu-width"
              :disabled="true"
              style="width: 250px;"
            ></Input>
            <Button
              type="primary"
              size="small"
              style="margin-left:10px;"
              @click="customerVisible = true"
            >选择</Button>
          </FormItem>
        </div>
        <div v-if="!(editType==='member')">
          <h3>
            项目预算及应收款
          </h3>
          <FormItem
            label="资格标预计"
            prop="qualifyPredict"
          >
            <Input
              v-model="projectData.qualifyPredict"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="预算金额(元)"
            prop="purchaseBudget"
          >
            <Input
              v-model="projectData.purchaseBudget"
              class="ivu-width"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            ></Input>
          </FormItem>
          <FormItem
            label="服务费类型"
            prop="serviceFeeType"
          >
            <Input
              v-model="projectData.serviceFeeType"
              class="ivu-width"
              disabled="disabled"
              style="width:80px;margin-right:10px;"
            ></Input>
            <span style="margin-right: 8px" v-if="projectData.serviceFeeType == '折扣'">
              (折扣率：{{ projectData.discount }}%)
            </span>
            <Button
              type="primary"
              size="small"
              @click="selectServiceFee"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            >服务费计算</Button>
          </FormItem>
          <FormItem
            label="预计服务费(元)"
            prop="servicePredict"
          >
            <Input
              v-model="projectData.servicePredict"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="应收服务费(元)"
            prop="receivables"
          >
            <Input
              v-model="projectData.receivables"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="中标金额"
            prop="winMoney"
          >
            <Input
              v-model="projectData.winMoney"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
        </div>
        <div v-if="!(editType==='member')">
          <h3>
            采购人基本资料
          </h3>
          <FormItem
            label="采购人名称"
            prop="purchaserName"
            style="width: 400px;"
          >
            <Input
              v-model="projectData.purchaserName"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="联系地址"
            prop="pAddress"
            :title="projectData.pAddress"
          >
            <Input
              v-model="projectData.pAddress"
              class="ivu-width"
              disabled="disabled"
              style="width:250px;margin-right:10px;"
            ></Input>
            <Button
              size="small"
              type="primary"
              @click="selectCgrVisible=true"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            >采购人选择</Button>
          </FormItem>
          <FormItem
            label="采购联系人"
            prop="pContacts"
          >
            <Input
              v-model="projectData.pContacts"
              class="ivu-width"
              disabled="disabled"
            ></Input>
          </FormItem>
          <FormItem
            label="联系方式"
            prop="pTel"
          >
            <Input
              v-model="projectData.pTel"
              class="ivu-width"
              disabled="disabled"
              style="width:160px;margin-right:10px;"
            ></Input>
            <Button
              size="small"
              type="primary"
              @click="contactSelect"
              :disabled="(!(editType==='info') && !(editType==='projectEdit')) || state"
            >联系人选择</Button>
          </FormItem>
          <div>
            <FormItem
              label="采购人属性"
              prop="pAttr"
            >
              <Input
                v-model="projectData.pAttr"
                class="ivu-width"
                disabled="disabled"
              ></Input>
            </FormItem>
            <FormItem
              label="客户所属行业"
              prop="clientSys"
            >
              <Input
                v-model="projectData.clientSys"
                class="ivu-width"
                disabled="disabled"
              ></Input>
            </FormItem>
          </div>
        </div>
        <div v-if="!(editType==='info')">
          <h3>
            业务基本信息
          </h3>
          <FormItem
            label="客户经理"
            prop="am"
          >
            <Input
              v-model="projectData.am"
              class="ivu-width"
              readonly
              style="width:162px;margin-right: 5px"
            ></Input>
            <Button
              :disabled="projectData.projectState === '项目结项'"
              type="primary"
              size="small"
              @click="addManagerVisible=!addManagerVisible"
            >添加/修改</Button>
          </FormItem>
          <FormItem
            label="客户经理（编辑）"
            v-if="addManagerVisible"
          >
            <Input
              :disabled="projectData.projectState === '项目结项'"
              v-model="extraInfo.addManager"
              type="text"
              style="width: 120px;margin-right:5px;"
            ></Input>
            <Button
              type="primary"
              size="small"
              @click="reviseManager(extraInfo.addManager)"
              style="margin-right:5px;"
            >覆盖</Button>
            <Button
              type="primary"
              size="small"
              @click="addManager(extraInfo.addManager)"
            >添加</Button>
          </FormItem>
          <FormItem
            label="项目助理"
            prop="aid"
          >
            <Input
              v-model="projectData.aid"
              class="ivu-width"
              :disabled="projectData.projectState === '项目结项' ? true : !(editType==='member') && !(editType==='projectEdit')"
            ></Input>
          </FormItem>
          <FormItem
            label="会务跟进人员"
            prop="merchandiser"
          >
            <Input
              v-model="projectData.merchandiser"
              class="ivu-width"
              :disabled="projectData.projectState === '项目结项' ? true : !(editType==='member') && !(editType==='projectEdit')"
            ></Input>
          </FormItem>
          <FormItem
            label="交接客户经理"
            prop="merchandiser"
          >
            <Input
              v-model="projectData.handoverAm"
              class="ivu-width"
              :disabled="projectData.projectState === '项目结项' ? !(editType==='member') && !(editType==='projectEdit') : true"
            ></Input>
          </FormItem>
          <FormItem
            label="交接项目助理"
            prop="merchandiser"
          >
            <Input
              v-model="projectData.handoverAid"
              class="ivu-width"
              :disabled="projectData.projectState === '项目结项' ? !(editType==='member') && !(editType==='projectEdit') : true"
            ></Input>
          </FormItem>
        </div>
      </Form>
      <Modal
        v-model="serviceFeeVisible"
        title="服务费类型"
        :transfer="false"
      >
        <serviceFee
          ref="service"
          :serviceData="serviceData"
        ></serviceFee>
        <div slot="footer">
          <Button @click="serviceFeeVisible=false">取消</Button>
          <Button
            @click="confirmServiceFee"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <Modal
        v-model="customerVisible"
        title="集团客户选择"
        :transfer="false"
      >
        <Form :label-width="80">
          <FormItem label="集团客户">
            <Select
              v-model="customername"
              @on-change="branchChange"
              style="width:250px;"
            >
              <Option
                v-for="customer in customerArr"
                :key="customer.id"
                :value="customer.fullName"
              >{{customer.fullName}}</Option>
            </Select>
          </FormItem>
          <FormItem label="分支机构">
            <Select
              v-model="branch"
              style="width:300px;"
            >
              <Option
                v-for="branch in branchArr"
                :key="branch.id"
                :value="branch.fullName"
              >{{branch.fullName}}</Option>
            </Select>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="customerVisible=false">取消</Button>
          <Button
            @click="confirmCustomer"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <!-- 采购人modal -->
      <Modal
        v-model="selectCgrVisible"
        width="800px"
        :transfer="false"
      >
        <div slot="header">
          采购人选择
        </div>
        <select-cgr @selected="selectedCgr"></select-cgr>
        <div slot="footer">
          <Button @click="selectCgrVisible=false">取消</Button>
          <!-- <Button type="primary">确定</Button> -->
        </div>
      </Modal>
      <!-- 采购人联系人 -->
      <Modal
        v-model="selectCgrInfoVisible"
        :transfer="false"
        title="采购联系人"
      >
        <Select v-model="selectContact">
          <Option
            v-for="contact in contactArr"
            :key="contact['联系人']"
            :value="contact['联系人']+'&'+contact['联系方式']"
          >{{contact['联系人']}}-{{contact['联系方式']}}</Option>
        </Select>
        <div slot="footer">
          <Button @click="selectCgrInfoVisible=false">取消</Button>
          <Button
            type="primary"
            @click="confirmContact"
          >确定</Button>
        </div>
      </Modal>
      <div slot="footer">
        <Button @click="medal=false">取消</Button>
        <Button
          type="primary"
          @click="ok('projectData')"
        >确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from "../../../lib/ajax"
import { formatDate } from '@/lib/tool'
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import ServiceFee from '@/components/setProject/serviceFee'
import SelectCgr from "@/components/setProject/selectCgr"
import eRequestUrls from '@/lib/eRequestUrls'

export default {
  components: {
    ServiceFee,
    SelectCgr,
  },
  props: ["medal", "projectData", 'editType'],
  data() {
    return {
      extraInfo: {
        childCompanies: [],
        cgmethodArr: [],
        businesstype: [],
        projectnatureArr: [],
        cgtype: [],
        moneysource: [],
        addManager: ''
      },
      serviceFeeVisible: false,
      serviceData: {},
      customerVisible: false,
      customerArr: [],
      branchArr: [],
      customername: '',
      branch: '',
      state: false,
      selectCgrVisible: false,
      contactArr: [],
      selectCgrInfoVisible: false,
      selectContact: '',
      addManagerVisible: false
    }
  },
  created() {
    this.getCgMethod()
    this.getbusiness()
    this.getcgtype()
    this.getsource()
  },
  computed: {
    roles() {
			return this.$store.state.session.roleNames
		},
    clMeetingRoom() {
      if (this.projectData.clMeetingRoom) {
        this.projectData.clMeetingRoom.beginTime = this.projectData.clMeetingRoom.beginTime.replace('T', ' ')
        return this.projectData.clMeetingRoom
      } else {
        return { beginTime: '暂无' }
      }
    }
  },
  methods: {
    contactSelect() {
      if (this.contactArr.length === 0) {
        this.$Message.info('该采购人暂无联系人信息，请前往采购人档案完善')
        return
      }
      this.selectCgrInfoVisible = true
    },
    confirmContact() {
      let contact = this.selectContact.split('&')
      this.projectData.pContacts = contact[0]
      this.projectData.pTel = contact[1]
      this.selectCgrInfoVisible = false
    },
    selectedCgr(cgrInfo) {
      // 清除联系人信息
      this.projectData.pTel = ''
      this.projectData.pContacts = ''
      this.selectContact = ''

      this.selectCgrVisible = false
      this.projectData.purchaserName = cgrInfo.purchase
      this.projectData.pAddress = cgrInfo.contactAddress
      this.projectData.clientSys = cgrInfo.sysIndustry
      this.projectData.pAttr = cgrInfo.purchaseSite
      // 联系方式处理.数据库数据可能有错
      this.contactArr = []
      try {
        let contact = cgrInfo.contactPersonOrWay;
        contact = contact.replace(/\'/g, '"');
        if(contact.indexOf('[') == -1){
          contact = `[${contact}]`;
        }
        contact = JSON.parse(contact);
        this.contactArr = contact;
      } catch (err) {
        console.error(err);
      }
    },
    confirmCustomer() {
      if (this.customername === '' || this.branch === '') {
        this.$Message.info('请先选择集团客户信息')
        return
      }
      this.projectData.specialCustomer = this.customername
      this.projectData.branchName = this.branch
      this.customerVisible = false
    },
    async branchChange(val) {
      // 清除分支信息
      this.branch = "";
      let customerArr = this.customerArr;
      for (let i = 0; i < customerArr.length; i++) {
        if (customerArr[i].fullName === val) {
          let rep = await ajax.get('/api/services/app/BaseEntity/GetBranchCliens',
            {
              params: {
                CompanyId: customerArr[i].id
              }
            }
          );
          this.branchArr = rep.data.result.items;
          break;
        }
      }
    },
    // 获取采购方式
    async getCgMethod() {
      let rep = await this.getDataDict('采购方式')
      this.extraInfo.cgmethodArr = rep;
    },
    //获取业务范围
    async getbusiness() {
      let rep = await this.getDataDict('业务范围', 1)
      this.extraInfo.businesstype = rep
    },
    //获取采购类别
    async getcgtype() {
      let rep = await this.getDataDict('采购类别')
      this.extraInfo.cgtype = rep
    },
    //获取资金来源
    async getsource() {
      let rep = await this.getDataDict('资金类型')
      this.extraInfo.moneysource = rep
    },
    ok(name) {
      if (this.projectData.pContacts === '') {
        this.$Message.info('请选择采购联系人')
        return
      }
      let clProjectDb = this.$refs[name].model
      this.$Modal.confirm({
        title: "修改数据",
        content: "是否确定修改此数据",
        onOk: () => {
          ajax.post("/api/services/app/ClProjectDb/CreateOrUpdate", { clProjectDb })
            .then(res => {
              if (res.data.success) {
                this.$Message.success("修改成功！");
              } else {
                this.$Message.success("修改出错！");
                return;
              }
              this.$emit("medal_ch", false);//改变父组件的值 是的子组件改变
            });
          this.$emit("medal_ch", false);//改变父组件的值 是的子组件改变
        },
        onCancel: () => {
          this.$Message.info("操作取消");
        }
      });
    },
    visibleChange(value) {
      if (!value) {
        this.$emit("medal_ch", value);
      }
    },
    // 获取地区
    async getArea(name) {
      this.getChildCompanies(name)
      let area = this.projectData.area.toString()
      this.projectData.area = area
    },
    async getChildCompanies(district) {
      let childcompany = this.projectData.companyName.toString()
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: `district == "${district}"`
        }
      })
      this.extraInfo.childCompanies = []
      if (rep.data.success) {
        this.extraInfo.childCompanies = rep.data.result.items
        this.projectData.companyName = childcompany
      }
    },
    confirmServiceFee() {
      let feeResult = this.$refs.service.getResult()
      this.projectData.serviceFeeType = feeResult.feeType
      this.projectData.servicePredict = feeResult.fee
      if (feeResult.discount) {
        this.projectData.discount = feeResult.discount
      }
      this.serviceFeeVisible = false
    },
    selectServiceFee() {
      if (this.projectData.purchaseBudget === '') {
        this.$Message.error('请先输入预算')
        return
      }
      this.serviceFeeVisible = true
      this.serviceData = {
        cgtype: this.projectData.buyerNature,
        amount: this.projectData.purchaseBudget
      }
    },
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    async businessChange(val, init = false) {
      let id = ''
      let type = ''
      this.extraInfo.businesstype.forEach((item, index) => {
        if (item.itemName == val) {
          id = this.extraInfo.businesstype[index].id
          type = this.extraInfo.businesstype[index].itemType
        }
      })
      // 清空项目性质
      if (!init) {
        this.projectData.projectProperty = "";
      }
      //this.extraInfo.projectnatureArr = [];
      let rep = await this.getDataDict(type, 0, id)
      this.extraInfo.projectnatureArr = rep;
    },
    bidplatform(val) {
      for (let i = 0; i < this.extraInfo.projectnatureArr.length; i++) {
        if (this.extraInfo.projectnatureArr[i].itemName == val) {
          this.projectData.bidPlatform = this.extraInfo.projectnatureArr[i].describe
        }
      }
    },
    // 删除会议室
    async deleteRoom() {
      let rep = await ajax.get('/api/services/app/ClMeetingRoom/GetRoomList', {
				params: {
					filter: `projectId==${this.projectData.id}`
				}
      })
      let obj = rep.data.result.items[0]
      // 项目人员或跟进人员可修改
      let aid = this.projectData.aid ? this.projectData.aid : ''
      let merchandiser = this.projectData.merchandiser ? this.projectData.merchandiser : ''
      if (aid.indexOf(this.$store.state.session.user.name) === -1 && merchandiser.indexOf(this.$store.state.session.user.name) === -1 && this.roles.indexOf('分公司项目经理') === -1) {
        this.$Message.info('此项目项目助理或跟进人员或项目经理才可删除')
        return
      }
      // 一个月之内的可以修改
      let beginTime = obj.beginTime.split('T')[0]
      beginTime = new Date(beginTime).getTime()
      let thisTime = new Date().getTime()
      let monthTime = 30*24*60*60*1000
      if (beginTime < thisTime - monthTime) {
        this.$Message.info('预约时间已超过一个月，不可删除')
        return
      }
			this.$Modal.confirm({
				title: "删除预约",
				content: "是否删除此预约",
				onOk: () => {
					ajax.delete('/api/services/app/ClMeetingRoom/Delete?id=' + obj.id).then((res) => {
						if (res.data.success) {
              this.$Message.info("删除成功")
              this.$emit("medal_ch", false)
              this.$emit("refresh")
						}
					})
				}
			})
    },
    reviseManager(val) {
      if (this.extraInfo.addManager) {
        this.$emit('reviseManager',val)
      }
    },
    addManager(val) {
      let arr = this.projectData.am.split(',')
      if (arr.indexOf(this.extraInfo.addManager) === -1) {
        this.$emit('addManager',val)
      } else {
        this.$Message.error('该客户经理已存在！')
      }
    }
  },
  watch: {
    projectData(val) {
      this.state = false
      if (this.projectData.projectState === '项目结项' || this.projectData.projectState === '项目失败') {
        this.state = true
      }
      this.businessChange(this.projectData.businessType, true)
      if (val.newProjectTime) {
        this.projectData.newProjectTime = val.newProjectTime.split('T')[0]
      }
      if (val.entrustAgreementTime) {
        this.projectData.entrustAgreementTime = val.entrustAgreementTime.split('T')[0]
      }
      if (val.district) {
        this.getArea(val.district)
      }
      // 获取采购人信息
      ajax.get(eRequestUrls.ClPurchase.GetPaged,{
        params: {
          filter: `purchase == "${val.purchaserName}"`,
          maxResultCount: 10,
        }
      }).then(res => {
        let cgrInfo = res.data.result.items[0]
        let contact = cgrInfo.contactPersonOrWay;
        contact = contact.replace(/\'/g, '"');
        if(contact.indexOf('[') == -1){
          contact = `[${contact}]`;
        }
        contact = JSON.parse(contact);
        this.contactArr = contact;
      })
    },
    async customerVisible(val) {
      if (val) {
        // 获取集团客户数据
        let rep = await ajax.get('/api/services/app/BaseEntity/GetSpecialCliens')
        this.customerArr = rep.data.result.items
      }
    }
  }
};
</script>
<style lang="less">
.detail_p .ivu-form .ivu-form-item-label {
  padding: 12px 4px 8px 0 !important;
}
.detail_p h3 {
  margin-bottom: 10px;
}
.detail_p {
  .ivu-modal {
    top: 20px;
  }
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #000 !important;
  }
  .ivu-select-selected-value {
    color: #000 !important;
  }
}
</style>
